import { env } from '@/lib/env'
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: env.VITE_ENVIRONMENT === 'production',
    },
    mutations: {
      retry: 0,
    },
  },
})
